import { ActionIcon, Group, Menu } from '@mantine/core';
import { IconTrash, IconBallpen, IconDots } from '@tabler/icons';
import { useContext } from 'react';
import { i18n } from '@lingui/core';
import { useNavigate } from 'react-router-dom';
import { useModalState } from '../../Dialogs';
import ContractTemplateNameModal from '../../../Organismns/Settings/Documents/ContractTemplates/ContractTemplateNameModal';
import { patchContractTemplate } from '../../../Service/restapi/contractTemplateService';
import { ToastS } from '../../../Service/ToastS';
import { ContractTemplateContext } from '../../../Service/Context/ContractTemplateContext';
import TemplatePreview from '../Templates/TemplatePreview';
import { ContractTemplateS } from '../../../Service/ContractTemplateS';

const ContractTemplateHeadActions = () => {
  const navigate = useNavigate();
  const { show: showEditModal, toggle: toggleEditModal } = useModalState(false);
  const { template } = useContext(ContractTemplateContext);
  const { id: templateId, name } = template ?? {};

  const changeName = async (newName: string) => {
    const res = await patchContractTemplate(templateId, { name: newName });
    if (res.ok) {
      navigate(`/settings/template/contract/${newName}`);
    } else {
      ToastS.generalError();
    }
  };

  const deleteTemplate = async () => {
    if (name) {
      const deleted = await ContractTemplateS.deleteTemplate(name);
      if (deleted) {
        navigate('/settings/contracts');
      }
    }
  };

  return (
    <>
      <Group>
        <TemplatePreview name={name} documentType="CONTRACT" style={undefined} />
        <Menu shadow="md" transition="scale-y" position="bottom-end">
          <Menu.Target>
            <ActionIcon>
              <IconDots />
            </ActionIcon>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Item icon={<IconBallpen size={16} />} onClick={toggleEditModal}>
              {i18n._('actions.edit')}
            </Menu.Item>
            <Menu.Item color="red" icon={<IconTrash size={16} />} onClick={deleteTemplate}>
              Löschen
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      </Group>
      {template && (
        <ContractTemplateNameModal
          show={showEditModal}
          toggle={toggleEditModal}
          finish={changeName}
          initialName={template.name}
        />
      )}
    </>
  );
};

export default ContractTemplateHeadActions;
